module.exports = __webpack_public_path__ + "static/media/droid_lod_2.b0383b0b.glb";